module.exports = __webpack_public_path__ + "media/images/common/menu_btn3-7427229716d5a14d724717c8086f6774.png";